// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"93bd5eb1","711":"ae86b8fc"}[chunkId] + ".chunk.js";
};